import React, { useEffect, useState, useContext } from "react";
import styles from "./BuyTrafficModal.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { createBuyTrafficLogic } from "./BuyTraffic.logic";
import { AuthContext } from "../../Constants/AuthProvider";
import { useFetchWithToken } from "../FetchWithToken/FetchWithToken";
import { ConfirmationModalContext } from "../../fautures/ConfirmationModalProvider";
import PriceText from "./PriceText.module";
import CtaBtns from "../CtaBtns/CtaBtns.module";
import ScrollShadowBox from "../ScrollShadowBox/ScrollShadow.module";
const formatPrice = (price) => {
  if (price == null) return "در حال بارگذاری...";
  return `${price.toLocaleString("fa-IR")} تومان`;
};
const BuyTrafficModal = ({
  isOpen,
  onClose,
  account,
  userWallet,
  receivedData,
  getInfo,
  loadingShow,
  singleMode,
}) => {
  const modalContext = useContext(ConfirmationModalContext);
  const { fetchWithToken, loading } = useFetchWithToken();
  const { onLogout } = useContext(AuthContext);
  const { payTrafficRenewPay, paybatchTrafficPay } = createBuyTrafficLogic(
    {
      fetchWithToken,
      getInfo,
      onLogout,
      account,
      closeFinalModal: onClose,
      getInfo,
    },
    modalContext
  );
  const closingRest = () => {
    setSelectedPlan(null);
    onClose();
  };
  useEffect(() => {
    loadingShow(loading);
  }, [loading]);
  const findById = (id) => {
    if (singleMode) {
      return receivedData.profile;
    } else {
      return receivedData.profiles.find((item) => item.id === id);
    }
  };
  const fetchTrafficPlans = async () => {
    let targetGig = findById(account);
    return targetGig.traffic.trafficPacks;
  };
  const [trafficPlans, setTrafficPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);

  React.useEffect(() => {
    if (isOpen) {
      const loadPlans = async () => {
        const data = await fetchTrafficPlans();
        setTrafficPlans(data);
      };

      loadPlans();
    }
  }, [isOpen, fetchTrafficPlans]);
  useEffect(() => {
    setCurrentStep(1);
  }, [isOpen]);
  if (!isOpen) return null;

  return (
    <div
      className={styles.custommodaloverlay}
      onClick={() => closingRest()}
      transition={{
        layout: { duration: 0.35, ease: [0.22, 0.61, 0.36, 1] },
      }}
    >
      <div
        className={styles.custommodalcontent}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.topBoxIcons}>
          <div className={styles.rightIconTop}>
            <i class="fa-solid fa-cart-plus"></i>
          </div>
          <button
            className={styles.custommodalclose}
            onClick={() => closingRest()}
          >
            ×
          </button>
        </div>

        {currentStep == 1 && (
          <>
            <div className={styles.renewtitle}>خریــد ترافیـــک</div>
            <p className={styles.descrenew}>
              لطفاً یکی از طرح‌های زیر را برای خرید ترافیک انتخاب کنید:
            </p>
            <ScrollShadowBox>
              <div className={styles.planlist}>
                {trafficPlans.map((plan) => (
                  <div
                    key={plan.GigPackID}
                    className={`${styles.plancard} ${
                      selectedPlan === plan.GigPackID ? styles.selected : ""
                    }`}
                    onClick={() => setSelectedPlan(plan.GigPackID)}
                  >
                    <div className={styles.planname}>
                      {plan.GigPackMode == "MIN" && (
                        <img
                          className={styles.topIcon}
                          src="/asets/NormalCharge.svg"
                        />
                      )}
                      {plan.GigPackMode == "MAX" && (
                        <img
                          className={styles.topIcon}
                          src="/asets/SuperCharge.svg"
                        />
                      )}
                      {plan.GigPackTitle}
                    </div>
                    <p className={styles.trafficamount}>
                      {plan.GigPackTraffic} GB
                    </p>
                    <div className={styles.littleSep}></div>
                    <p className={styles.planprice}>
                      <PriceText
                        selected={
                          selectedPlan === plan.GigPackID ? true : false
                        }
                        value={plan.GigPackPrice}
                      />
                    </p>
                  </div>
                ))}
              </div>
            </ScrollShadowBox>
            {/* {selectedPlan && (
              <div className={styles.summary}>
                <div className={styles.titler}>خلاصه خرید:</div>
                <p>
                  طرح انتخاب‌شده:{" "}
                  {
                    trafficPlans.find((plan) => plan.GigPackID === selectedPlan)
                      ?.GigPackTitle
                  }
                </p>
                <p>
                  مبلغ قابل پرداخت:
                  {trafficPlans
                    .find((plan) => plan.GigPackID === selectedPlan)
                    ?.GigPackPrice.toLocaleString("fa-IR")}{" "}
                  تومان
                </p>
              </div>
            )} */}
            <motion.div
              layout
              className={styles.bottomContainer}
              transition={{
                layout: { duration: 0.35, ease: [0.22, 0.61, 0.36, 1] },
              }}
            >
              <div className={styles.modalactions}>
                <AnimatePresence mode="wait">
                  {!selectedPlan ? (
                    <motion.div
                      key="hint"
                      initial={{ opacity: 0, y: 15 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.3 }}
                      className={styles.hintBar}
                    >
                      لطفاً یک مورد را انتخاب کنید
                    </motion.div>
                  ) : (
                    <motion.div
                      key="details"
                      initial={{ opacity: 0, y: 40, scale: 0.9 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: 30, scale: 0.96 }}
                      transition={{
                        type: "spring",
                        duration: 0.6,
                        bounce: 0.35,
                      }}
                      className={`${styles.bottomContent} ${
                        selectedPlan ? styles.bottomVisible : ""
                      }`}
                    >
                      <div className={styles.packDetails}>
                        <motion.div
                          className={styles.bottomRow}
                          initial={{ opacity: 0, y: 15 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: 0.1 }}
                        >
                          <div className={styles.bottomLabel}>
                            طرح انتخاب شده
                          </div>
                          <div className={styles.bottomValue}>
                            {
                              trafficPlans.find(
                                (plan) => plan.GigPackID === selectedPlan
                              )?.GigPackTitle
                            }
                          </div>
                        </motion.div>

                        <motion.div
                          className={styles.bottomRow}
                          initial={{ opacity: 0, y: 15 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: 0.25 }}
                        >
                          <div className={styles.bottomLabel}>
                            مبلغ قابل پرداخت
                          </div>
                          <div className={styles.bottomValue}>
                            {trafficPlans
                              .find((plan) => plan.GigPackID === selectedPlan)
                              ?.GigPackPrice.toLocaleString("fa-IR")}{" "}
                            تومان
                          </div>
                        </motion.div>
                      </div>

                      <CtaBtns onAtion={() => setCurrentStep(2)}>
                        پرداخت
                      </CtaBtns>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </motion.div>
          </>
        )}
        {currentStep === 2 && (
          <>
            <div className={styles.renewtitle}>انتخاب محل پرداخت</div>

            <div className={styles.invoiceSummary}>
              <p>
                مجموع مبلغ قابل پرداخت:{" "}
                {trafficPlans
                  .find((plan) => plan.GigPackID === selectedPlan)
                  ?.GigPackPrice.toLocaleString("fa-IR")}{" "}
                تومان
              </p>
            </div>
            <div className={styles.choosepayment}>
              <div
                className={
                  trafficPlans.find((plan) => plan.GigPackID === selectedPlan)
                    ?.GigPackPrice > userWallet
                    ? `${styles.eachitemonpayment} ${styles.disablePayment}`
                    : styles.eachitemonpayment
                }
                onClick={() =>
                  trafficPlans.find((plan) => plan.GigPackID === selectedPlan)
                    ?.GigPackPrice <= userWallet &&
                  payTrafficRenewPay(
                    selectedPlan,
                    trafficPlans.find((plan) => plan.GigPackID === selectedPlan)
                      ?.GigPackPrice,
                    account
                  )
                }
              >
                <div className={styles.topicon}>
                  <i class="fa-light fa-wallet"></i>
                </div>
                <div className={styles.textofpay}>
                  کیف پول
                  {trafficPlans.find((plan) => plan.GigPackID === selectedPlan)
                    ?.GigPackPrice > userWallet && (
                    <>
                      <br />
                      عدم موجودی کافی
                    </>
                  )}
                </div>
              </div>
              <div
                className={styles.eachitemonpayment}
                onClick={() =>
                  paybatchTrafficPay(
                    trafficPlans.find((plan) => plan.GigPackID === selectedPlan)
                      ?.GigPackID,
                    account
                  )
                }
              >
                <div className={styles.topicon}>
                  <i class="fa-light fa-credit-card-front"></i>
                </div>
                <div className={styles.textofpay}>درگاه پرداخت</div>
              </div>
            </div>
            <div className={styles.modalactions}>
              <CtaBtns onAtion={() => setCurrentStep(1)}>بازگشت</CtaBtns>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BuyTrafficModal;
